export const prefix = 'os:';
export var FieldNames;
(function (FieldNames) {
    FieldNames["OptimizationObjective"] = "os:optimizationObjective";
})(FieldNames || (FieldNames = {}));
export var BusinessObjectiveOption;
(function (BusinessObjectiveOption) {
    BusinessObjectiveOption["ClickThroughRate"] = "ctr";
    BusinessObjectiveOption["ConversionRate"] = "cvr";
})(BusinessObjectiveOption || (BusinessObjectiveOption = {}));
export const defaultFormValues = {
    [FieldNames.OptimizationObjective]: BusinessObjectiveOption.ClickThroughRate,
};
export const BUSINESS_OBJECTIVE_TO_LOCALIZATION_KEY = {
    [BusinessObjectiveOption.ClickThroughRate]: 'RECS_MODEL_BUSINESS_OBJECTIVE_CLICK_THROUGH_RATE',
    [BusinessObjectiveOption.ConversionRate]: 'RECS_MODEL_BUSINESS_OBJECTIVE_CONVERSION_RATE',
};
export const BUSINESS_OBJECTIVE_TO_DESCRIPTION_KEY = {
    [BusinessObjectiveOption.ClickThroughRate]: 'RECS_MODEL_BUSINESS_OBJECTIVE_CLICK_THROUGH_RATE_DESCRIPTION',
    [BusinessObjectiveOption.ConversionRate]: 'RECS_MODEL_BUSINESS_OBJECTIVE_CONVERSION_RATE_DESCRIPTION',
};
